import {MoveRatingCategories} from "../utils/gameEnums";

const OverviewRow = ({moveRatingCategory, blackMoveRatings, whiteMoveRatings}) => {
    const whiteCount = whiteMoveRatings.reduce((sum, currentValue) =>
        currentValue.category === moveRatingCategory ? sum + 1 : sum
    , 0)

    const blackCount = blackMoveRatings.reduce((sum, currentValue) =>
            currentValue.category === moveRatingCategory ? sum + 1 : sum
        , 0)

    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "0.6rem",
            marginBottom: "0.6rem",
            color: "#888"
        }}>
            <p style={{margin: "0"}}>{whiteCount}</p>
            <div style={{display: "flex", alignItems: "center"}}>
                <p style={{margin: "0", marginRight: "0.5rem"}}>{moveRatingCategory.title}</p>
                {moveRatingCategory.symbol()}
            </div>

            <p style={{margin: "0"}}>{blackCount}</p>
        </div>
    )
}

const AnalysisOverview = ({whiteMoveRatings, blackMoveRatings}) => {

    return (
        <div style={{border: "1px solid #ccc", borderRadius: "0.3rem", padding: "1rem", fontFamily: "monospace"}}>
            <OverviewRow moveRatingCategory={MoveRatingCategories.BEST_MOVE} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
            <OverviewRow moveRatingCategory={MoveRatingCategories.GOOD_MOVE} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
            <OverviewRow moveRatingCategory={MoveRatingCategories.ALRIGHT_MOVE} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
            <OverviewRow moveRatingCategory={MoveRatingCategories.INACCURACY} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
            <OverviewRow moveRatingCategory={MoveRatingCategories.MISTAKE} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
            <OverviewRow moveRatingCategory={MoveRatingCategories.BLUNDER} whiteMoveRatings={whiteMoveRatings} blackMoveRatings={blackMoveRatings}/>
        </div>
    )
}

export default AnalysisOverview;